document.addEventListener('DOMContentLoaded', function () {
  const faqSections = document.querySelectorAll('[data-custom-faq]');

  if (!faqSections.length) return;

  faqSections.forEach(function (section) {
    initCustomFaq(section);
  });

  function initCustomFaq(section) {
    const items = section.querySelectorAll('.custom-faq__item');
    const onlyOneOpen = section.dataset.onlyOneOpen === 'true';

    if (!items.length) return;

    items.forEach(function (item) {
      const button = item.querySelector('.custom-faq__question');

      if (!button) return;

      button.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        if (onlyOneOpen) {
          items.forEach(function (otherItem) {
            if (otherItem === item) return;

            otherItem.classList.remove('is-open');

            const otherButton = otherItem.querySelector('.custom-faq__question');

            if (otherButton) {
              otherButton.setAttribute('aria-expanded', 'false');
            }
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-custom-faq]');

    if (section) {
      initCustomFaq(section);
    }
  });
});